import _ from 'lodash'
import {
  getHealthieRequest,
  useHealthieUserInfo,
  useUpdateClient,
} from './careHooks'
import { getHealthieUserId } from 'utils/authLocalStorage'
import { SkuNames } from './useFlow'
import {
  HEALTHIE_GET_USER_STRING,
  useHealthieAPIs,
} from 'apis/HealthieApiClient'

export const isNoteStartsWith = (note, key) => {
  return note
    ?.replace(/<[^>]*>/g, '')
    ?.trim()
    ?.startsWith(key)
}

const filterQuickNotes = (userQuickNotesArray, noteKey) => {
  return userQuickNotesArray.filter((item) =>
    noteKey
      ? !_.isEmpty(item) && !isNoteStartsWith(item, noteKey)
      : !_.isEmpty(item) &&
        SkuNames.map((name) => isNoteStartsWith(item, name)).includes(true)
  )
}

const useUpdateQuickNotes = () => {
  const { user } = useHealthieUserInfo()
  const { updateClient } = useUpdateClient()
  const healthieUserId = getHealthieUserId()
  const { getUser } = useHealthieAPIs()

  const updateQuickNotes = async (newQuickNotes, noteKey) => {
    let _user = user
    if (_.isEmpty(user)) {
      const { data } = await getHealthieRequest({
        healthieRequest: getUser,
        queryString: HEALTHIE_GET_USER_STRING,
        variables: { id: healthieUserId, include_tags: true },
        operationName: 'getUser',
      })
      _user = data?.user
    }
    const userQuickNotes = _user.quick_notes
    const userQuickNotesArray = _.split(userQuickNotes, '|')

    const newArray = filterQuickNotes(userQuickNotesArray, noteKey)
    newArray.push(newQuickNotes)
    const newUserQuickNotes = newArray
      .map((item) => item?.replace(/<[^>]*>/g, '')?.trim())
      .join(' | ')
    updateClient({
      variables: {
        id: getHealthieUserId(),
        quick_notes: newUserQuickNotes,
      },
    })
  }
  return {
    updateQuickNotes,
  }
}

export default useUpdateQuickNotes
